import { yup } from '@framework/validation';
import {
  Datatype,
  FieldDatatype,
} from '../../../../expressions/datatype/Datatype';

/**
 * Ritorna dinamicamente lo schema di validazione per un campo di output
 * di un servizio asincrono in base al tipo di dato.
 */
export function getDatatypeOutputSchema(
  datatype: FieldDatatype | null | undefined,
) {
  if (!datatype) return yup.mixed().notRequired();

  if (datatype.type === Datatype.String) {
    return yup.string().notRequired();
  }
  if (datatype.type === Datatype.Number) {
    return yup.number().notRequired();
  }
  if (datatype.type === Datatype.Boolean) {
    return yup.boolean().notRequired();
  }
  if (datatype.type === Datatype.Date) {
    return yup.string().stringDate().notRequired();
  }
  // Non sono gestiti gli altri tipi di dato, non strippiamo per evitare problemi in futuro
  return yup.mixed().notRequired();
}
